export default __webpack_public_path__ + "assets/e9f7bbca502ab2c9536a4a66f08210c8.jpg";